export default "__VITE_ASSET__DS1k0Mv7__"